"use client";

import { useEffect, useState } from "react";

// Google Funding Choices is the consent platform the AdSense loader pulls in
// for visitors in regions that require a consent notice. It exposes `googlefc`
// on the window only once a message has actually been served, so this control
// renders itself only where there is a real consent choice to revisit —
// visitors outside those regions never see a dead link.
declare global {
  interface Window {
    googlefc?: {
      showRevocationMessage?: () => void;
    };
  }
}

export default function ManageConsent() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (typeof window.googlefc?.showRevocationMessage === "function") {
      setAvailable(true);
      return;
    }

    // The CMP loads asynchronously and may lose a race with hydration, so poll
    // briefly instead of checking once on mount. Give up after ~10s rather
    // than leaving a timer running for the life of the page.
    let attempts = 0;
    const timer = window.setInterval(() => {
      if (typeof window.googlefc?.showRevocationMessage === "function") {
        setAvailable(true);
        window.clearInterval(timer);
      } else if (++attempts > 20) {
        window.clearInterval(timer);
      }
    }, 500);

    return () => window.clearInterval(timer);
  }, []);

  if (!available) return null;

  return (
    <li>
      <button
        type="button"
        onClick={() => window.googlefc?.showRevocationMessage?.()}
        className="text-sm text-white/60 hover:text-white transition-colors duration-150"
      >
        Privacy &amp; cookie settings
      </button>
    </li>
  );
}
